import React from "react"
import { ORDER_MODE } from "../OrderMode"

import style from "./index.module.sass"

function FirstSlot(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { slot, orderMode } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function renderSlot(label, fromLabel, endedLabel) {
    if (label) {
      return (
        <div className="text-center">
          <div className={style.firstDelivery}>{label}</div>
          <div className={style.firstDeliveryLabel}>{fromLabel}</div>
        </div>
      )
    } else {
      return endedLabel
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  let label = null
  let fromLabel
  let endedLabel
  switch (orderMode) {
    case ORDER_MODE.DELIVERY:
      fromLabel = I18n.t("pages.locations.venues.venue_box.delivery_from")
      endedLabel = I18n.t("pages.locations.venues.venue_box.ended_deliveries")
      if (slot) {
        const { date, start_time } = slot
        label = start_time

        if (!date) break

        let jsDate = new Date(date)
        if (jsDate.getDate() !== new Date().getDate()) {
          label = `${jsDate.toLocaleString(I18n.locale, {
            weekday: "short",
            day: "2-digit",
          })}, ${start_time}`
        }
      }
      break
    case ORDER_MODE.PICKUP:
      fromLabel = I18n.t("pages.locations.venues.venue_box.takeaway_from")
      endedLabel = I18n.t(
        "pages.locations.venues.venue_box.ended_takeaway_slots"
      )
      if (slot) {
        const { picking_times = [] } = slot
        label = picking_times[0]
      }
      break
    default:
      return null
  }

  // -------------------------------------

  return renderSlot(label, fromLabel, endedLabel)
}

export default FirstSlot
